import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "~hooks/useNotification";
import { useApi } from "~shared/api";
import type { FixtureTransformed } from "../types";
import { getFixtureListQueryKey } from "./useFetchAllSeasonFixtures";

export const useDeleteFixture = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  const notification = useNotification();
  return useMutation({
    mutationFn: async (fixtureId: string) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${fixtureId}`,
        method: "DELETE",
      });
    },
    onSuccess: (response: any, fixtureId: string) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        queryClient.setQueryData(getFixtureListQueryKey({ sport, organizationId, seasonId }), (oldFixtures: FixtureTransformed[]) =>
          (oldFixtures || []).filter((x) => x.fixtureId !== fixtureId),
        );

        notification.success({
          message: formatMessage({ id: "fixture.delete.success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
